import { NebulaFighterTheme } from './schemes/NebulaFighterTheme';

const themeMap = {
  NebulaFighterTheme, 
};

export function themeCreator(theme) {
  return themeMap[theme];
}
